"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILD_PASSPORT = 'BUILD_PASSPORT';
exports.CHANGE_PASSPORT = 'CHANGE_PASSPORT';
function changePassport(passportInfo) {
    return {
        type: exports.CHANGE_PASSPORT,
        passportCountry: passportInfo.passportCountry,
        passportNumber: passportInfo.passportNumber
    };
}
exports.changePassport = changePassport;
exports.DefaultState = {
    countryOptionList: [],
    passportNumber: '',
    passportCountry: '',
};
